import { axiosConfig } from '../api/axios-config.js'

export const aiStaffMembers = {
  /**
   * 取得客服人員列表
   */
  get: (params, token) => {
    const config = { ...token }
    if (params) config.params = params
    return axiosConfig.get('/api/ai/staff', config)
  },

  /**
   * 取得單一客服人員
   */
  getOne: (id, token) => axiosConfig.get(`/api/ai/staff/${id}`, token),

  /**
   * 取得統計資料
   */
  getStatistics: (params, token) => {
    const config = { ...token }
    if (params) config.params = params
    return axiosConfig.get('/api/ai/staff/statistics', config)
  },

  /**
   * 建立新客服人員
   */
  create: (data, token) => axiosConfig.post('/api/ai/staff', data, token),

  /**
   * 更新客服人員
   */
  update: (id, data, token) => axiosConfig.put(`/api/ai/staff/${id}`, data, token),

  /**
   * 刪除客服人員
   */
  delete: (id, token) => axiosConfig.delete(`/api/ai/staff/${id}`, token),

  /**
   * 批量更新狀態
   */
  batchUpdateStatus: (data, token) => axiosConfig.post('/api/ai/staff/batch-status', data, token),

  /**
   * 從 Line 匯入
   */
  importFromLine: (data, token) => axiosConfig.post('/api/ai/staff/import-line', data, token),

  /**
   * 同步快取
   */
  syncCache: (token) => axiosConfig.post('/api/ai/staff/sync-cache', {}, token),

  /**
   * 取得暫停狀態
   */
  getPauseStatus: (token) => axiosConfig.get('/api/ai/pause/status', token),

  /**
   * 設定暫停控制
   */
  setPauseControl: (data, token) => axiosConfig.post('/api/ai/pause/control', data, token)
}